import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/title'
const api = createApi(baseUrl)

// 用户相关API
export const articleTitleApi = {
  list: api('list', 'get'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  batchDelete: api('batch_delete', 'get'),
  search: api('search', 'get'),
  ai: api('ai', 'post'),
  batchUpload: api('batch_upload', 'post'),
  inputText: api('input_text', 'post'),
  config: api('config', 'get'),
  select: api('select', 'get'),
  retry: api('retry', 'post'),
}